import { faLanguage } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@/components/ui/button';
import { useTranslator } from '@/hooks/useTranslator';
import { INSPECTOR_UI_ATTRIBUTE } from './inspectElement';

export function InspectorButton({
  active,
  left,
  onToggle,
}: {
  active: boolean;
  /** Clears the sidebar, which owns the corner itself. */
  left: number;
  onToggle: () => void;
}) {
  const { getTranslation: t } = useTranslator({ page: 'translationInspector' });
  const label = active ? t('button.stop') : t('button.start');

  return (
    <div
      {...{ [INSPECTOR_UI_ATTRIBUTE]: '' }}
      className='fixed bottom-3 z-50 flex items-center gap-2'
      style={{ left }}
    >
      <Button
        variant={active ? 'default' : 'outline'}
        size='icon-lg'
        className='rounded-full shadow-md'
        aria-label={label}
        aria-pressed={active}
        title={label}
        onClick={onToggle}
      >
        <FontAwesomeIcon icon={faLanguage} />
      </Button>
      {active && (
        <span className='rounded-full border bg-popover px-3 py-1 text-xs text-popover-foreground shadow-md'>
          {t('hint')}
        </span>
      )}
    </div>
  );
}
